module.exports = __webpack_public_path__ + "assets/images/maintenanceLog-089d20115868f4185683f17f16513302.png";